module.exports = __webpack_public_path__ + "static/data_privacy-dd0d765c09645f446085021b2fdbd237.png";